import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-footer',
  standalone: false,
  templateUrl: './custom-footer.component.html',
  styleUrls: ['./custom-footer.component.scss']

})
export class CustomFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}